


class AmcGrantReportController

    ### @ngInject ###
    constructor: (ModelService, program, config, grantReport, data) ->
        @ModelService = ModelService
        @program = program
        @config = config.config
        @sections = config.sections.sections
        @grantReport = grantReport
        @reportId = "#{@program.id}/#{@grantReport.grant_year}"
        @data = data

        @outcomeNames = [
            {name: "ed_award_rate_objective", unit: '%', max: 100, key: 'ed_award'}
        ]

        if grantReport.grant_year <= 2015
            @outcomeNames = @outcomeNames.concat([
                {name: "full_ed_award_objective", unit: 'Member(s)', key: 'full_ed_award'}
                {name: "credential_rate_objective", unit: '%', max: 100, key: "hse"}
                {name: "job_placement_rate_objective", unit: '%', max: 100, key: 'job'}
            ])
        else
            @outcomeNames = @outcomeNames.concat([
                {name: 'no_credential_objective', unit: 'Member(s)', key: 'no_credential'}
                {name: 'credential_30d_objective', unit: '%', key: 'credential_30d'}
                {name: 'credential_1y_objective', unit: '%', key: 'credential_1y'}
                {name: 'job_placement_30d_objective', unit: '%', key: 'job_30d'}
                {name: 'job_placement_1y_objective', unit: '%', key: 'job_1y'}
            ])

    save: (data) ->
        return @ModelService.patch('amc_grant_report', @reportId, data)

    lockReport: ->
        data = {locked: !@grantReport.locked}
        return @save(data)

    updateModel: (data) =>
        angular.copy(data, @grantReport)
        return @grantReport

    saveSection: (section, data) ->
        formData = {}
        formData[section.name] = data
        return @save(formData)


module.controller('AmcGrantReportController', AmcGrantReportController)
